module.exports = __webpack_public_path__ + "static/media/CSK-horiz-tablet-hover@2x.a6cb757e.png";